var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgWork(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2538_6710)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M29 5H36V34H29V5ZM27 5C27 3.89543 27.8954 3 29 3H36C37.1046 3 38 3.89543 38 5V34C38 35.1046 37.1046 36 36 36H29C27.8954 36 27 35.1046 27 34V5ZM23 17H16V34H23V17ZM16 15C14.8954 15 14 15.8954 14 17V34C14 35.1046 14.8954 36 16 36H23C24.1046 36 25 35.1046 25 34V17C25 15.8954 24.1046 15 23 15H16ZM1 24C1 22.8954 1.89543 22 3 22H10C11.1046 22 12 22.8954 12 24V34C12 35.1046 11.1046 36 10 36H3C1.89543 36 1 35.1046 1 34V24Z",
    fill: "#F8D210"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2538_6710"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWork);
export default __webpack_public_path__ + "static/media/work.4aec6563083be0d774c55a1598ad467d.svg";
export { ForwardRef as ReactComponent };